import { render, staticRenderFns } from "./TableInativacaoLoteStatus.vue?vue&type=template&id=55805581&scoped=true&"
import script from "./TableInativacaoLoteStatus.vue?vue&type=script&lang=js&"
export * from "./TableInativacaoLoteStatus.vue?vue&type=script&lang=js&"
import style0 from "./TableInativacaoLoteStatus.vue?vue&type=style&index=0&id=55805581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55805581",
  null
  
)

export default component.exports